/** @jsx jsx */
import { jsx } from "@emotion/react";
import { CSSObject } from "@emotion/serialize";

export type PropsParagraphWithPreferredBreak = {
  children: React.ReactElement[];
  keyPrefix: string;
  cssP?: CSSObject;
  cssSpan?: CSSObject;
};

export const ParagraphWithPreferredBreak = (
  props: PropsParagraphWithPreferredBreak
): React.ReactElement => {
  const { children, keyPrefix, cssP, cssSpan } = props;
  return (
    <p css={cssP}>
      {children.map((child, c) => (
        <span key={keyPrefix + c}>
          <span css={{ ...cssSpan, display: "inline-block" }}>{child}</span>{" "}
        </span>
      ))}
    </p>
  );
};

export default ParagraphWithPreferredBreak;
